import React from 'react';
import { formatCurrency } from '../../utils/currency';

export default function CurrencyDisplay({ value, currency, className = '' }) {
  if (value == null || value === '') return <span className="text-ink-faint">—</span>;
  return (
    <span className={`tabular-nums ${className}`}>{formatCurrency(value, currency)}</span>
  );
}
